import { useQuery } from 'react-query';

import { SalesReport } from '@/domain/models/SalesReport';
import { getClient } from '@/lib/restClient';
import { FilterParams, SalesReportService } from '@/services/SalesReport';

interface Report {
  salesReport: SalesReport;
  isLoading: boolean;
  error: Error | null;
}

export const useSalesReport = (
  params: FilterParams,
  enabled = false
): Report => {
  const salesReportService = new SalesReportService(getClient());

  const {
    data: salesReport = {} as SalesReport,
    error,
    isLoading,
    isFetching,
    isPreviousData,
  } = useQuery<SalesReport, Error>(
    ['salesReport', params],
    () => salesReportService.aggregateSales(params),
    {
      enabled,
      keepPreviousData: true,
    }
  );

  return {
    salesReport,
    isLoading: isLoading || (isFetching && isPreviousData),
    error: error,
  };
};
